module.exports = __webpack_public_path__ + "img/professional-placeholder.8ac7af9d.jpg";